<template functional>
    <div class="detail-tabs">
        <!-- 标题 -->
        <div class="tabs-title">详情介绍</div>
        <!-- 内容 -->
        <div v-if="props.detailContent" v-html="props.detailContent"></div>
        <img
            v-for="(image, index) in props.imageList"
            :key="index"
            :src="image"
            :alt="`详情介绍图片${index + 1}`"
            class="detail-intro-image">
    </div>
</template>

<script>
export default {
    props: {
        detailContent: {
            type: String,
            default: "",
        },
        imageList: {
            type: Array,
            default: () => [],
        },
    },
};
</script>

<style scoped>
.detail-tabs{
    margin-top: 28px;
    margin-bottom: 50px;
    padding: 26px 28px;
    color: #625e58;
    border: 1px solid #e4e5f0;
    border-radius: 16px;
    background-color: #fff;
    box-shadow: 0 12px 36px rgba(57, 60, 111, .05);
    line-height: 1.8;
}
.tabs-title{
    position: relative;
    margin-bottom: 20px;
    padding-left: 14px;
    color: #1f1d1a;
    font-size: 20px;
    font-weight: 700;
}
.tabs-title::before{
    position: absolute;
    top: 4px;
    bottom: 4px;
    left: 0;
    width: 3px;
    content: "";
    background: #8d9afc;
    border-radius: 3px;
}
.detail-intro-image{
    display: block;
    width: 100%;
    height: auto;
}

@media (max-width: 767px){
    .detail-tabs{
        padding: 22px 18px;
        border-radius: 14px;
    }
}
</style>
